import { getCookie } from '@/shared/lib/formatter'
import { UserAvatarIcon } from '@/shared/ui/icons'

interface PopoverTitleProps {
  src?: string
  user?: { fullname?: string }
}

export function PopoverTitle({ src, user }: PopoverTitleProps) {
  const userFromCookieUsername = getCookie('username')
  const usersPosition = getCookie('position')

  return (
    <div className="flex items-center gap-2.5 px-[7px] py-0 border-b border-[#e0e0e0]">
      <div className="w-[38px] h-[38px] rounded-full object-cover flex items-center justify-center border border-[#c4c4c4] text-[17px] font-bold bg-(--primary-btn-light-bg) text-(--main-title-color)">
        {src ? (
          <img src={src} alt="User Avatar" width={36} height={36} className="w-9 h-9 rounded-full" />
        ) : (
          <div className="flex items-center justify-center text-[17px] text-(--main-title-color)">
            {user?.fullname?.charAt(0)}
          </div>
        )}
      </div>
      <div className="flex flex-col">
        <h3 className="text-base font-semibold text-(--main-title-color)">
          {userFromCookieUsername}
        </h3>
        <p className="m-0 text-[0.8em] text-(--main-title-color)">
          {usersPosition}
        </p>
      </div>
    </div>
  )
}
